import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import BrandsHub from "@/pages/BrandsHub";
import BrandDetail from "@/pages/BrandDetail";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import PartnerPortal from "@/pages/PartnerPortal";
import PartnerApply from "@/pages/PartnerApply";
import PartnerDashboard from "@/pages/PartnerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";
import { trackPageView } from "@/utils/analytics";

// Analytics Tracker Component
function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const pageTitle = document.title;
    const pageUrl = location.pathname;
    
    trackPageView(pageUrl, pageTitle);
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App bg-ewss-navy">
      <BrowserRouter>
        <AuthProvider>
          <Navigation />
          <AnalyticsTracker />
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/brands" element={<BrandsHub />} />
            <Route path="/brands/:slug" element={<BrandDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partner-portal" element={<PartnerPortal />} />
            <Route path="/partner/apply" element={<PartnerApply />} />
            <Route path="/partner/dashboard" element={<PartnerDashboard />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/analytics" element={<AnalyticsDashboard />} />
          </Routes>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
